// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { chatConfigDev } from '../../../shared/chat-config';

export const environment = {
  production: false,
  test: false,
  googleTagManager: {
    id: 'GTM-M99QRBB'
  },
  uaAdminUrl: 'https://admin.dev.urbanairparks.com',
  parkApiUrl: 'https://ua-web-dev-parks-api.azurewebsites.net',
  productApiUrl: 'https://ua-web-dev-products-api.azurewebsites.net',
  invoiceApiUrl: 'https://ua-web-dev-invoice-api.azurewebsites.net',
  accountApiUrl: 'https://ua-web-dev-accounts-api.azurewebsites.net',
  mediaApiUrl: 'https://ua-web-dev-media-api.azurewebsites.net',
  bookingApiUrl: 'https://ua-web-dev-booking-api-v3.azurewebsites.net',
  unleashedApiUrl: 'https://ua-web-dev-unleashed-api-v3.azurewebsites.net',
  uaPhoneNumber: '417-867-5309',
  cookieName: 'dev-snap-booking-cart',
  bookingCookieName: 'dev-snap-booking',
  enableGtm: false,
  auth: {
    issuer: 'https://ua-web-dev-auth-api.azurewebsites.net',
    clientId: 'urban-air',
    clientSecret: 'hvUxcVhby0M35cB69si9',
    scopes: [
      'accounts',
      'accounts:create',
      'accounts:read',
      'accounts:update',
      'account-waivers:create',
      'account-waivers:read',
      'account-waivers:update',
      'invoices',
      'invoices:create',
      'invoices:preview',
      'openid',
      'payments',
      'profile',
      'offline_access'
    ],
    cookies: {
      domain: '.unleashedbrands.com',
      duration: 86400000,
      namespace: 'ua_dev',
      secure: false
    }
  },
  chatConfig: chatConfigDev
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
